<template>
  <!-- 协议管理页面 -->
  <div class="main-content" v-loading="loading">
    <!-- 标题 -->
    <!-- 协议搜索栏 -->
    <search-box :search-list="searchList" @search="searchProtocol" @add="addProtocol" @del="deleteProtocols" @reset="resetSearch" :selectIds="selectIds"/>
    <!-- 协议总表+分页器 -->
    <manage-table id="manageTable" :table-list="tableList" :table-data="tableData"  @edit="handleEdit" @copy="handleCopy"
    :total="total" :page-size="size" :currentPage="page" @handleSelect="handleSelect" @pagechange="pageChange" @sizeChange="sizeChange" @select="handleSelect" />
  </div>
</template>

<script>
import SearchBox from '@/components/table/SearchBox.vue'
import ManageTable from '@/components/table/ManageTable.vue'
import { protocolManageList } from '@/data/tableList'
import { getProtocol, deleteProtocol } from '@/api/protocol/protocol'

export default {
  components: {
    SearchBox,
    ManageTable
  },
  data () {
    return {
      // 表头列表
      tableList: protocolManageList,
      // 搜索栏列表
      searchList: protocolManageList,
      // 协议列表数据
      tableData: [],
      // 选中的协议id
      selectIds: [],
      // 当前页
      page: 1,
      // 每页显示的数量
      size: 10,
      // 总数量
      total: 0,
      loading: false
    }
  },
  mounted () {
    // 获取协议列表
    this.getProtocolList()
    // 字典下拉框赋值
    this.$assignDictOptions(this.searchList, { protocolType: 'protocol_type' }, this.selectDictionary)
    this.$assignDictOptions(this.searchList, { deviceType: 'product_type' }, this.selectDictionary)
  },
  computed: {
    selectDictionary () {
      return this.$store.getters.getDictionaryList
    }
  },
  methods: {
    // 获取协议列表 - 公共方法
    async fetchProtocolList (params = {}) {
      this.loading = true
      try {
        const res = await getProtocol({
          page: this.page,
          size: this.size,
          ...params
        })
        if (res.code === 200) {
          this.tableData = res.data.records.map(row => ({
            ...row,
            protocolType: this.$getDictLabel(this.selectDictionary, 'protocol_type', row.protocolType),
            deviceType: this.$getDictLabel(this.selectDictionary, 'product_type', row.deviceType)
          }))
          this.total = res.data.total
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$message.error(error);
      } finally {
        this.loading = false
      }
    },
    // 初始化加载
    getProtocolList () {
      this.fetchProtocolList()
    },

    // 搜索协议
    searchProtocol (params) {
      // 保存搜索参数
      this.searchParams = params
      this.page = 1 // 重置页码
      this.fetchProtocolList(params)
    },

    resetSearch () {
      this.searchParams = {}
      this.page = 1
      this.getProtocolList()
    },
    // 选择协议
    handleSelect (selection) {
      this.selectIds = selection.map(item => item.id)
    },
    // 分页器
    pageChange (val) {
      this.page = val
      this.fetchProtocolList(this.searchParams)
    },

    // 页码大小改变
    sizeChange (val) {
      this.size = val
      this.page = 1 // 重置页码
      this.fetchProtocolList(this.searchParams)
    },

    // 操作栏按钮
    // 编辑
    handleEdit (row) {
      this.$editHandler('/protocol/create', '编辑协议', 'ProtocolCreateView', 'edit', row.id)
    },
    handleCopy (row) {
      this.$editHandler('/protocol/create', '编辑协议', 'ProtocolCreateView', 'copy', row.id)
    },

    // 删除
    async deleteProtocols () {
      const success = await this.$deleteHandler(deleteProtocol, this.selectIds.toString(), '协议')
      if (success) {
        this.selectIds = []
        this.getProtocolList()
      }
    },

    // 新增协议
    addProtocol () {
      this.$addHandler('/protocol/create', '创建协议', 'add')
    }
  }
}
</script>

<style>
</style>
